export const AreasRels = {
    getAreas: 'getAreas',
    getArea: 'getArea',
    updateArea: 'updateArea',
    deleteArea: 'deleteArea',
    createArea: 'createArea'
};
